<mat-select [formControl]="kontroll" panelWidth="250px" (opened)="vedMenyAapnet()" (closed)="vedMenyLukket()">
  @for (overskrift of overskrifter; track overskrift.nivaa) {
    <mat-option [value]="overskrift.nivaa">
      <span [innerHTML]="formatertNavn(overskrift)" class="overskrift"></span>
    </mat-option>
  }
</mat-select>
